import { useNavigate, Link } from 'react-router-dom';
import useNotificationInbox from '../../hooks/useNotificationInbox';
import NotificationInboxShell from '../Notifications/NotificationInboxShell';

const StudentNotificationsPage = () => {
  const navigate = useNavigate();
  const inbox = useNotificationInbox('student');

  const openMessages = async () => {
    const selected = inbox.selected;
    if (!selected) return;
    await inbox.markItemRead(selected);

    const conversationId = selected.metadata?.conversationId;
    if (conversationId) {
      navigate(`/messages?conversation=${conversationId}`);
      return;
    }
    const messageRequestId = selected.metadata?.messageRequestId;
    if (messageRequestId) {
      navigate(`/messages?request=${messageRequestId}`);
      return;
    }
    navigate('/messages');
  };

  return (
    <NotificationInboxShell
      subtitle="Review reminders, bookings, messages, and support notices in one place."
      inbox={inbox}
      getDetailHeading={(selected) =>
        selected.type === 'booking_confirmation' ? 'Your session has been confirmed' : selected.title
      }
      renderDetailActions={(selected) => (
        <div className="mt-6 flex flex-wrap gap-3">
          {['booking_confirmation', 'cancellation', 'session_reminder'].includes(selected.type) && (
            <Link
              to="/my-sessions"
              className="rounded-lg bg-brand-medium-blue px-5 py-2.5 text-sm font-medium text-white hover:bg-brand-dark-blue"
            >
              View Session
            </Link>
          )}
          {selected.type === 'message' && (
            <button
              type="button"
              onClick={openMessages}
              className="rounded-lg border-2 border-brand-medium-blue px-5 py-2.5 text-sm font-medium text-brand-medium-blue hover:bg-brand-light-blue/20"
            >
              Open Message
            </button>
          )}
        </div>
      )}
    />
  );
};

export default StudentNotificationsPage;
